import React from 'react';
import { Section, preloader } from 'spectacle-ppa';
import { i18nData } from 'helpers/i18n';

import headingSlide from '../../baseSlides/headingSlide';
import balloonSlide from '../../baseSlides/balloonSlide';
import videoSlide from '../../baseSlides/videoSlide';

import imagePPALogo from '../../images/logo_ppa.png';
import esPowerStance from '../../images/characters/esPowerStance.png';
import esHandsOutWehey from '../../images/characters/esmeralda_hands_out_wehey.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel2_en from './level2_operationDarkroom.md';
import markdownFileLevel2_fr_CA from './level2_operationDarkroom.fr_CA.md';
import markdownFileLevel3_en from './level3_operationShowerPower.md';
import markdownFileLevel3_fr_CA from './level3_operationShowerPower.fr_CA.md';
import markdownFileLevel4_en from './level4_operationKeepCarCool.md';
import markdownFileLevel4_fr_CA from './level4_operationKeepCarCool.fr_CA.md';
import markdownFileLevel5_en from './level5_operationGoCarFree.md';
import markdownFileLevel5_fr_CA from './level5_operationGoCarFree.fr_CA.md';

const markdownFileLevel2 = i18nData({
  en: new MarkdownScript(markdownFileLevel2_en),
  fr_CA: new MarkdownScript(markdownFileLevel2_fr_CA)
});
const markdownFileLevel3 = i18nData({
  en: new MarkdownScript(markdownFileLevel3_en),
  fr_CA: new MarkdownScript(markdownFileLevel3_fr_CA)
});
const markdownFileLevel4 = i18nData({
  en: new MarkdownScript(markdownFileLevel4_en),
  fr_CA: new MarkdownScript(markdownFileLevel4_fr_CA)
});
const markdownFileLevel5 = i18nData({
  en: new MarkdownScript(markdownFileLevel5_en),
  fr_CA: new MarkdownScript(markdownFileLevel5_fr_CA)
});

const levels = {
  '2': { md: markdownFileLevel2 },
  '3': { md: markdownFileLevel3 },
  '4': { md: markdownFileLevel4 },
  '5': { md: markdownFileLevel5 }
}

export function preloadMissionAssignment () {
  preloader([
    imagePPALogo,
    esPowerStance,
    esHandsOutWehey
  ]);
}

function missionAssignmentSection ({ level, regionData, i18n }) {
  const md = i18n(levels[level].md);
  const missionTitle = md.getSectionMetadata('Mission Assignment', 'Title', regionData);
  return (
    <Section id="mission-assignment">

      {/* Sizzle */}
      {headingSlide({
        id: 'sizzle',
        beforeImage: imagePPALogo,
        subHeading: i18n`Mission ${level-1}:<br/> ${missionTitle}`,
        notes: md.getSubSectionAsHtml('Mission Assignment', 'Notes', false, regionData),
        bgColor: 'black'
      })}

      {/* Mission Intro Video*/}
      {videoSlide({
        id: 'mission-intro-video',
        notes: md.getSubSectionAsHtml('Mission Intro Video', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Mission Intro Video', 'YouTube', regionData)
      })}

      {/* Mission Instructions levels 2 & 4 */}
      { (level === 2 || level === 4) &&
        balloonSlide({
          id: 'instructions',
          characterSide: 'right',
          characterImage: esPowerStance,
          notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
          html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
        })
      }

      {/* Mission Instructions levels 3 & 5 */}
      { (level === 3 || level === 5) &&
        balloonSlide({
          id: 'instructions',
          characterSide: 'right',
          characterImage: esHandsOutWehey,
          notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
          html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
        })
      }

    </Section>
  );
}

export default missionAssignmentSection;



// WEBPACK FOOTER //
// ./programs/keepCool/sections/70_missionAssignment/missionAssignmentSection.jsx